import React from 'react'
import { ROLES, SUMMARY } from '../constants'

import Footer from './Footer'
import avatar from '../assets/images/index.png'

const Header = () => (
  <header id="header">
    <div className="inner">
      <a href="#" className="image avatar">
        <img src={avatar} alt="" />
      </a>
      <h1>
        <strong>I am Emanuele</strong>, a seasoned
        <br />
        <strong>Software Engineer</strong>
        <br />
        with vast experience in <strong>Mobile Development</strong>.
      </h1>
    </div>
    <Footer />
  </header>
)

export default Header
